import { render, staticRenderFns } from "./LoopDetail.vue?vue&type=template&id=dac327c4&scoped=true&"
import script from "./LoopDetail.vue?vue&type=script&lang=js&"
export * from "./LoopDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoopDetail.vue?vue&type=style&index=0&id=dac327c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac327c4",
  null
  
)

export default component.exports